<div class="full-height-container">
  <mat-card class="full-height-container">
    <mat-card-content class="content-panel full-height-container">
      <div class="flex-row">
        <app-component-header (downloadClickEvent)="this.handleDownloadClickEvent('download-request')"
                              (refreshClickEvent)="this.refreshView()"
                              [checkAutoRefreshByDefault]="false"
                              [hideColumnsButton]="true"
                              [hideUploadButton]="true"
                              [startRefreshTimer]="this.refreshComplete" [subtitleSegments]="getUrlSegments()"
                              class="full-width">
        </app-component-header>
      </div>
      <div class="flex-row table-container">
        <ag-kpi-sidebar [sidebar]="kpiSidebar" class="mg-r-s"></ag-kpi-sidebar>
        <ag-grid-angular (columnVisible)="onColumnVisible($event)"
                         (filterChanged)="onFilterChanged($event)"
                         (firstDataRendered)="onFirstDataRendered($event)"
                         (gridReady)="onGridReady($event)"
                         (paginationChanged)="onPaginationChanged($event)"
                         (selectionChanged)="onRowSelectionChanged($event)"
                         (viewportChanged)="onViewportChanged($event)"
                         [columnDefs]="tableColumns"
                         [gridOptions]="baseAgGridOptions"
                         [overlayNoRowsTemplate]="noRowsTemplate"
                         [paginateChildRows]="true"
                         [rowData]="rowData"
                         [suppressPropertyNamesCheck]="true"
                         class="ag-theme-quartz ag-grid-flex">
        </ag-grid-angular>

        <ng-template #footerActionButtonPanel>
          <button (click)="this.onRetryButtonClick()" [disabled]="!this.canBulkRetry" class="white-font-color mg-r-m" color="accent" mat-raised-button>
            <i class="fa-sharp fa-light fa-ban"></i>
            Bulk Retry
          </button>
          <button (click)="this.onCancelButtonClick()" [disabled]="!this.canBulkCancel" class="white-font-color mg-r-m" color="accent" mat-raised-button>
            <i class="fa-sharp fa-light fa-ban"></i>
            Cancel Requests
          </button>
          <button [routerLink]="['task', 'add']" class="white-font-color mg-r-m" color="primary" mat-raised-button>
            <i class="fa-sharp fa-light fa-add"></i>
            New Download Request
          </button>
        </ng-template>
      </div>
    </mat-card-content>
  </mat-card>
</div>

